import {Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-toggle-switch',
    templateUrl: './toggle-switch.component.html',
    styleUrls: ['./toggle-switch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ToggleSwitchComponent implements OnInit {
    @Input() toggled: boolean;

    @Output() onChange: EventEmitter<boolean> = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
    }

    onToggled() {
        this.onChange.emit(this.toggled = !this.toggled);
    }
}
